import { useState, useEffect } from "react";
import { NAVLINKS } from "../../data/constans";
import { HiMenu, HiX } from "react-icons/hi";

type Props = {};

const Navbar: React.FC<Props> = (props: Props): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    document.addEventListener("click", () => setIsOpen(false));
    return () => {
      document.removeEventListener("click", () => setIsOpen(false));
    };
  }, []);

  return (
    <nav
      id="navbar"
      className={`fixed top-0 ${isOpen ? "" : "h-[8vh]"} n4-gradient-bg z-10 w-full shadow-md md:h-[8vh]`}
    >
      <div className="h-full pl-2 pr-4 md:flex md:items-center md:justify-between md:pr-6">
        <div className="flex h-[8vh] items-center justify-between md:h-full">
          <a href="#aboutme">
            <img className="h-[6vh] border-2 border-white shadow-lg" src="logo.jpg" alt="logo" />
          </a>

          <button
            onClick={(e) => {
              e.stopPropagation();
              toggleMenu();
            }}
            className="block text-white md:hidden"
            aria-label="Toggle Menu"
          >
            {isOpen ? <HiX className="size-8" /> : <HiMenu className="size-8" />}
          </button>
        </div>
        <div className={`${isOpen ? "" : "hidden md:block"} flex items-center justify-between`}>
          <ul
            className="mt-4 flex flex-col space-y-4 border-white py-2 font-medium md:mt-0 md:flex-row md:items-center md:justify-center md:space-x-8 md:space-y-0 md:p-0"
            onClick={() => toggleMenu()}
          >
            {NAVLINKS.map((navlink, index) => (
              <li key={index} className="flex items-center text-left text-lg text-white hover:text-white">
                <a
                  href={navlink.url}
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent menu from closing before navigation
                    setIsOpen(false);
                  }}
                  className="relative after:absolute after:bottom-0 after:left-0 after:h-[2px] after:w-0 after:origin-right after:bg-white after:opacity-30 after:transition-all after:duration-300 after:content-[''] hover:after:w-full"
                >
                  {navlink.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
